/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type MonitorRecommendationJobCreationResponseDto = {
    jobId?: string;
    requestStatus: MonitorRecommendationJobCreationResponseDto.requestStatus;
};

export namespace MonitorRecommendationJobCreationResponseDto {

    export enum requestStatus {
        SUCCESS = 'SUCCESS',
        TECHNICAL_ERROR = 'TECHNICAL_ERROR',
        THROTTLING_ERROR = 'THROTTLING_ERROR',
    }


}
